import type { Volume } from "../types/landing";
export const volumes: Volume[] = [
  {
    number: 1,
    stage: "Inicio",
    title: "Japonés desde cero",
    subtitle: "Hiragana, katakana y primeros pasos",
    problem: "Querés empezar, pero no sabés si arrancar por la escritura, el vocabulario o la gramática.",
    benefit: "Empezás con una base organizada de escritura y expresiones iniciales.",
    topics: ["Hiragana", "Katakana", "Primeros pasos y expresiones iniciales"],
    example: "Antes de pasar a las frases, ordenás los dos silabarios en un mismo lugar y sabés qué viene después.",
    crop: { x: 122, y: 340, w: 244, h: 368 },
  },
  {
    number: 2,
    stage: "Inicio",
    title: "Tus primeras frases",
    subtitle: "Vocabulario y estructuras esenciales",
    problem: "Conocés palabras sueltas, pero no sabés cómo unirlas en un mensaje.",
    benefit: "Comprendés cómo construir mensajes sencillos y presentaciones.",
    topics: ["Vocabulario esencial", "Estructuras esenciales", "Presentaciones y mensajes sencillos"],
    example: "Pasás de memorizar palabras a armar una presentación breve con estructuras que podés reutilizar.",
    crop: { x: 398, y: 334, w: 220, h: 372 },
  },
  {
    number: 3,
    stage: "N5",
    title: "Bases del N5",
    subtitle: "Gramática y práctica paso a paso",
    problem: "Leés reglas gramaticales, pero no terminás de ver cómo se aplican.",
    benefit: "Estudiás estructuras básicas mediante explicaciones, ejemplos y ejercicios.",
    topics: ["Gramática de nivel N5", "Explicaciones con ejemplos", "Ejercicios paso a paso"],
    example: "Cada estructura se explica, se ve en ejemplos y se practica: no queda solo en la teoría.",
    crop: { x: 640, y: 338, w: 230, h: 368 },
  },
  {
    number: 4,
    stage: "Repaso N5",
    title: "Consolidá tu japonés",
    subtitle: "Lectura y repaso del N5",
    problem: "Estudiaste varios temas y no sabés cuáles tenés firmes y cuáles no.",
    benefit: "Conectás conocimientos y detectás qué temas conviene reforzar.",
    topics: ["Lectura", "Repaso del N5", "Temas para reforzar"],
    example: "Antes de avanzar, leés y repasás para identificar qué volver a mirar de los tomos anteriores.",
    crop: { x: 892, y: 344, w: 248, h: 366 },
  },
  {
    number: 5,
    stage: "N4",
    title: "Rumbo al N4",
    subtitle: "Nuevas estructuras y expresiones",
    problem: "Sentís que terminaste lo básico y no sabés cómo seguir.",
    benefit: "Avanzás progresivamente hacia construcciones de mayor complejidad.",
    topics: ["Nuevas estructuras", "Nuevas expresiones", "Avance progresivo hacia el N4"],
    example: "Sabés exactamente cuál es el paso siguiente después del N5, sin buscar un curso nuevo.",
    crop: { x: 230, y: 598, w: 240, h: 344 },
  },
  {
    number: 6,
    stage: "N4",
    title: "Japonés en contexto",
    subtitle: "Lecturas y situaciones cotidianas",
    problem: "Entendés frases aisladas, pero te cuesta seguirlas dentro de una situación.",
    benefit: "Interpretás el idioma dentro de situaciones concretas.",
    topics: ["Lecturas", "Situaciones cotidianas", "Interpretación en contexto"],
    example: "Las estructuras que estudiaste aparecen dentro de situaciones cotidianas, no en oraciones sueltas.",
    crop: { x: 490, y: 592, w: 264, h: 348 },
  },
  {
    number: 7,
    stage: "Integración N4",
    title: "Integración N4",
    subtitle: "Ejercicios y autoevaluación",
    problem: "Necesitás revisar todo lo estudiado y saber qué repasar.",
    benefit: "Integrás los temas estudiados y orientás el repaso.",
    topics: ["Ejercicios de integración", "Autoevaluación", "Orientación del repaso"],
    example: "La autoevaluación te muestra a qué tomo conviene volver para reforzar un tema puntual.",
    crop: { x: 792, y: 602, w: 258, h: 342 },
  },
];
